import React from 'react';
import './Terms.scss';

const Terms = () => (
  <div className="terms-page container">
    <h1>Terms of Service</h1>

    <p className="updated">Last updated: February 9, 2026</p>

    <p>
      By using the Chiti app or web app ("Service"), you are agreeing to be bound by the following terms and conditions ("Terms of Use").
    </p>

    <section>
      <h2>Basic Terms</h2>
      <ul>
        <li>You are responsible for keeping your login and password safe.</li>
        <li>The Service should not be used to store sensitive information such as bank account numbers, credit card information, or passwords.</li>
        <li>We are not responsible for any information stored with the Service.</li>
        <li>We are not responsible for data loss, unauthorised access, or other issues relating to your data. You are encouraged to maintain backups of any important information you store using the Service.</li>
      </ul>
    </section>

    <section>
      <h2>General Terms</h2>
      <ul>
        <li>We reserve the right to modify or terminate the Service for any reason, without notice at any time.</li>
        <li>We may update these Terms occasionally, without notice at any time. Continued use of the Service after changes indicates your acceptance of the updated Terms.</li>
        <li>We reserve the right to refuse service to anyone for any reason at any time.</li>
        <li>We may suspend or terminate access to accounts that violate these Terms or for any other reason at our discretion. Upon termination you must stop using the Service. Termination does not affect any rights or obligations that accrued prior to termination.</li>
      </ul>
    </section>
  </div>
);

export default Terms;
